module.exports = __webpack_public_path__ + "img/venus20.013fc8bf.png";